import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { MealItemCustomization } from '../../../../app/data/models/mealItems/mealItemCustomization';
import api from '../../../../app/api/api';
import { MealItemCustomizationFormData } from '../../../../app/data/models/mealItems/mealItemCustomizationFormData';
import { toMealItemCustomizationModel } from '../../../../app/data/models/mealItems/mealItemCustomizationModel';
import { MealItemCustomizationModel } from '../../../../app/data/models/mealItems/mealItemCustomizationModel';
export interface MealItemCustomizationState {
  mealItemCustomizations: MealItemCustomization[];
  status: string;
}

const initialState: MealItemCustomizationState = {
  mealItemCustomizations: [],
  status: 'idle',
};

export const fetchMealItemCustomizationsAsync = createAsyncThunk<
  MealItemCustomization[],
  { restaurantId: string }
>(
  'mealItemCustomization/fetchMealItemCustomizationsAsync',
  async ({ restaurantId }) => {
    return await api.MealItemCustomization.list(restaurantId);
  }
);

export const fetchMealItemCustomizationAsync = createAsyncThunk<
  MealItemCustomizationModel,
  { restaurantId: string; customizationId: string }
>(
  'mealItemCustomization/fetchDetails',
  async ({ restaurantId, customizationId }, thunkAPI) => {
    try {
      return await api.MealItemCustomization.details(
        restaurantId,
        customizationId
      );
    } catch (error: unknown) {
      if (error instanceof Error) {
        return thunkAPI.rejectWithValue({ error: error.message });
      }
      return thunkAPI.rejectWithValue({ error: 'An unknown error occurred' });
    }
  }
);

export const updateMealItemCustomizationAsync = createAsyncThunk<
  void,
  {
    restaurantId: string;
    customizationId: string;
    data: MealItemCustomizationFormData;
  }
>(
  'mealItemCustomization/update',
  async ({ restaurantId, customizationId, data }, thunkAPI) => {
    try {
      await api.MealItemCustomization.update(
        restaurantId,
        customizationId,
        toMealItemCustomizationModel(data)
      );
      await thunkAPI.dispatch(
        fetchMealItemCustomizationsAsync({ restaurantId })
      );
    } catch (error: unknown) {
      if (error instanceof Error) {
        return thunkAPI.rejectWithValue({ error: error.message });
      }
      return thunkAPI.rejectWithValue({ error: 'An unknown error occurred' });
    }
  }
);

export const deleteMealItemCustomizationAsync = createAsyncThunk<
  void,
  { restaurantId: string; customizationId: string }
>(
  'mealItemCustomization/delete',
  async ({ restaurantId, customizationId }, thunkAPI) => {
    try {
      await api.MealItemCustomization.delete(restaurantId, customizationId);
      await thunkAPI.dispatch(
        fetchMealItemCustomizationsAsync({ restaurantId })
      );
    } catch (error: unknown) {
      if (error instanceof Error) {
        return thunkAPI.rejectWithValue({ error: error.message });
      }
      return thunkAPI.rejectWithValue({ error: 'An unknown error occurred' });
    }
  }
);

export const mealItemCustomizationSlice = createSlice({
  name: 'mealItemCustomization',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchMealItemCustomizationsAsync.pending, (state) => {
      state.status = 'pendingFetchMealItemCustomizations';
    });
    builder.addCase(
      fetchMealItemCustomizationsAsync.fulfilled,
      (state, action) => {
        state.mealItemCustomizations = action.payload;
        state.status = 'idle';
      }
    );
    builder.addCase(fetchMealItemCustomizationsAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});
